import { DataTransform } from "@nemuru-eng/js-api-client";
import { addressMapper } from "../../../components/modules/kyc/shared/AutocompleteAddressHeadless/components/GoogleMapsAutocomplete/mappers/addressMapper";

export const DocumentAddressMapper = {
  reverseMap(data) {
    return DataTransform.camelToSnake(addressMapper.toDto(data.address));
  },
};
